var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1533.76 1699.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_3);}.cls-2{fill:url(#Degradado_sin_nombre_14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: 766.88,
    y1: 1701.91,
    x2: 766.88,
    y2: 2.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#d83931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f64a2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff4f2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14",
    x1: 933.97,
    y1: 1699.41,
    x2: 980.42,
    y2: 1699.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c33"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,1700C0,1370.7.09,331.39.09,2.09c4,12.81,7.84,25.68,12,38.43C68.19,211.07,148,369.44,256.31,512.93c68,90,146.17,169.86,237.43,236.57C581.91,814,678.11,862.19,783,892.94c18.51,5.43,36.49,12.37,54.66,18.78a788.87,788.87,0,0,1,114.88,51.21c70.76,38.49,291,188.08,394,331.83,138.24,193,185.47,383.9,187.2,407.15",
    transform: "translate(0 -2.09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M934,1699.91a3,3,0,0,1,2.67-1l43.78.16a4,4,0,0,1-.46.84Z",
    transform: "translate(0 -2.09)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.ccc43719290ecc8783d253969863f38c.svg";
export { ForwardRef as ReactComponent };